import { Validators } from '@angular/forms';
import { IExpandableObject } from '../expandable-object';

import {
    DynamicField,
    DynamicFieldType,
    DynamicFieldTypes,
    DynamicLabel,
    noZeroRequiredValidator,
    InputTypes,
    NumericInputTypes,
    SelectInputTypes,
    LabelPositions,
    LabelPosition,
    IDatepickerOptions,
} from '@mt-ng2/dynamic-form';

import { IOfficePickupOverride } from '../interfaces/office-pickup-override';
import { IOfficePickupOverrideDynamicControlsParameters, OfficePickupOverrideDynamicControls } from '../form-controls/office-pickup-override.form-controls';

export class OfficePickupOverrideControlsPartial extends OfficePickupOverrideDynamicControls {
    constructor(officepickupoverride?: IOfficePickupOverride, additionalParameters?: IOfficePickupOverrideDynamicControlsParameters) {
        super(officepickupoverride, additionalParameters);

        (<DynamicField>this.Form.StartTime).type.inputType =  InputTypes.Timepicker;
        (<DynamicField>this.Form.EndTime).type.inputType =  InputTypes.Timepicker;
        (<DynamicField>this.Form.StartTime).type.timepickerOptions = { meridian: true };
        (<DynamicField>this.Form.EndTime).type.timepickerOptions = { meridian: true };

        const today = new Date();
        const datepickerOptions: IDatepickerOptions = { 
            minDate: { 
                year: today.getFullYear(), 
                month: today.getMonth() + 1, 
                day: today.getDate() 
            } 
        };

        (<DynamicField>this.Form.FromDate).type.datepickerOptions = datepickerOptions;
        (<DynamicField>this.Form.FromDate).setRequired(true);
        (<DynamicField>this.Form.FromDate).labelHtml = '<span class="dynamic-field-label"><label>Starts On</label></span>';
        (<DynamicField>this.Form.ToDate).labelHtml = '<span class="dynamic-field-label"><label>Ends On</label></span>';

        (<DynamicField>this.Form.IsRecurringMon).labelHtml = '<label>Every Monday</label>';
        (<DynamicField>this.Form.IsRecurringTue).labelHtml = '<label>Every Tuesday</label>';
        (<DynamicField>this.Form.IsRecurringWed).labelHtml = '<label>Every Wednesday</label>';
        (<DynamicField>this.Form.IsRecurringThu).labelHtml = '<label>Every Thursday</label>';
        (<DynamicField>this.Form.IsRecurringFri).labelHtml = '<label>Every Friday</label>';
        (<DynamicField>this.Form.IsRecurringSat).labelHtml = '<label>Every Saturday</label>';
        (<DynamicField>this.Form.IsRecurringSun).labelHtml = '<label>Every Sunday</label>';
    }
}
